import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormEcouponService } from '@web-nx-ng-tsc/shared-feat';
import { CommonModule } from '@angular/common';
import { IconfirmOTP } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { FormsModule } from '@angular/forms';
import { map, timer, takeWhile, tap } from 'rxjs';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'ecoupon-shared-ui-lip-ecoupon-otp',
  imports: [MatInputModule, MatButtonModule, FormsModule, CommonModule],
  templateUrl: './lip-ecoupon-otp.component.html',
  styleUrl: './lip-ecoupon-otp.component.scss',
})
export class LipEcouponOtpComponent {
  ref_no: any;
  @Input() seconds = 300;

  @Input() set refOTP(value: string) {
    this.ref_no = value;
  }
  @Input() set errMsg(value: string) {
    this.errMessage = value;
  }
  // @Input() set errStatus(value: number) {
  //   this.errMsgStatus = value;
  // }
  @Output() emitSendOTPAgain = new EventEmitter<any>();
  @Output() emitOtp = new EventEmitter<{ value: IconfirmOTP; timeout: boolean }>();

  private readonly loggingService = inject(LoggingService);
  // private readonly formEcouponService = inject(FormEcouponService);

  // refOtpSignal = this.formEcouponService.getRefOtpSignal();
  // errMsgStatus = 10;
  errMessage = '';
  otpForm = signal<IconfirmOTP>({
    no: '',
    ref_no: '',
  });
  timeout = false;

  onClick() {
    this.otpForm().ref_no = this.ref_no;
    this.loggingService.log('this.otpForm()', this.otpForm());
    this.loggingService.log('timeout', this.timeout);
    this.emitOtp.emit({ value: this.otpForm(), timeout: this.timeout });
  }
  onClickResend() {
    this.otpForm().ref_no = this.ref_no;
    this.loggingService.log('this.otpForm()', this.otpForm());
    this.loggingService.log('otpAgain', this.timeout);
    this.seconds = 300;
    this.startCountdown();
    this.emitSendOTPAgain.emit(this.timeout);
  }

  // timeRemaining$ = timer(0, 1000).pipe(
  //   map((n) => (this.secon ds - n) * 1000),
  //   takeWhile((n) => n >= 0)
  // );

  timeRemaining$ = timer(0, 1000).pipe(
    map((n) => (this.seconds - n) * 1000),
    takeWhile((n) => n >= 0),
    tap((remainingTime) => {
      if (remainingTime === 0) {
        this.timeout = true;
        this.emitOtp.emit({ value: this.otpForm(), timeout: this.timeout }); // ✅ Emit when timeout is true
      }
    })
  );
  startCountdown() {
    this.timeRemaining$ = timer(0, 1000).pipe(
      map((n) => (this.seconds - n) * 1000),
      takeWhile((n) => n >= 0),
      tap((remainingTime) => {
        if (remainingTime === 0) {
          this.timeout = true;
          this.emitOtp.emit({ value: this.otpForm(), timeout: this.timeout }); // ✅ Emit when timeout is true
        }
      })
    );
  }
}
